const CustomerIndex = () => import("@/pages/crm/customer/CustomerIndex");
const CustomerDetail = () => import("@/pages/crm/customer/CustomerDetail");
const CustomerAdd = () => import("@/pages/crm/customer/CustomerAdd");
const CustomerEdit = () => import("@/pages/crm/customer/CustomerEdit");
const CustomerSingle = () => import("@/pages/crm/customer/CustomerSingle");
const CustomerContactAdd = () =>
  import("@/pages/crm/customercontacts/CustomerContactAdd");
const CustomerContactEdit = () =>
  import("@/pages/crm/customercontacts/CustomerContactEdit");
const CustomerLocationAdd = () =>
  import("@/pages/crm/customerlocations/CustomerLocationAdd");
const CustomerLocationEdit = () =>
  import("@/pages/crm/customerlocations/CustomerLocationEdit");
const CustomerAuditTrail = () => import("@/pages/crm/customer/CustomerAuditTrail");
const CustomerAuditTrailHistory = () => import("@/pages/crm/customer/CustomerAuditTrailHistory");
const CustomerTimeSeriesReport = () => import("@/pages/crm/customer/CustomerTimeSeriesReport");
const CustomerGrowerAdd = () => import("@/pages/crm/customergrowers/CustomerGrowerAdd");
const CustomerGrowerEdit = () => import("@/pages/crm/customergrowers/CustomerGrowerEdit");
const CustomerFieldAdd = () => import("@/pages/crm/customerfields/CustomerFieldAdd");
const CustomerFieldEdit = () => import("@/pages/crm/customerfields/CustomerFieldEdit");

export class CustomerRoutes {
  constructor() {
    this.route_root = "customer";
    this.type_single = "Customer";
    this.type_plural = "Customers";

    this.routes = [
      {
        path: this.route_root,
        component: {
          render(c) {
            return c("router-view");
          }
        },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            component: CustomerIndex,
            meta: { requiresAuth: true }
          },
          {
            path: "add",
            name: "Add",
            component: CustomerAdd,
            meta: { requiresAuth: true }
          },
          {
            path: ":customer_id",
            component: CustomerSingle,
            props: route => ({ route_meta: route.meta }),
            children: [
              {
                path: "",
                component: CustomerDetail,
                name: this.type_single,
                meta: { requiresAuth: true }
              },
              {
                path: "edit",
                name: "Edit",
                component: CustomerEdit,
                meta: { requiresAuth: true }
              },
              {
                path: "audit-trail",
                name: `${this.type_single} Audit Trail`,
                component: CustomerAuditTrail,
                meta: { requiresAuth: true }
              },
              {
                path: "audit-trail-history",
                name: `${this.type_single} Audit Trail History`,
                component: CustomerAuditTrailHistory,
                meta: { requiresAuth: true }
              },
              {
                path: "time-series-report",
                name: `${this.type_single} Time Series Report`,
                component: CustomerTimeSeriesReport,
                meta: { requiresAuth: true }
              },
              {
                path: "contacts/add",
                name: "Add Customer Contact",
                component: CustomerContactAdd,
                meta: { requiresAuth: true }
              },
              {
                path: "contacts/:customer_contact_id/edit",
                name: "Edit Customer Contact",
                component: CustomerContactEdit,
                meta: { requiresAuth: true }
              },
              {
                path: "locations/add",
                name: "Add Customer Location",
                component: CustomerLocationAdd,
                meta: { requiresAuth: true }
              },
              {
                path: "locations/:customer_location_id/edit",
                name: "Edit Customer Location",
                component: CustomerLocationEdit,
                meta: { requiresAuth: true }
              },
              {
                path: "growers/add",
                name: "Add Customer Grower",
                component: CustomerGrowerAdd,
                meta: { requiresAuth: true }
              },
              {
                path: "growers/:customer_grower_id/edit",
                name: "Edit Customer Grower",
                component: CustomerGrowerEdit,
                meta: { requiresAuth: true }
              },
              {
                path: "fields/add",
                name: "Add Customer Field",
                component: CustomerFieldAdd,
                meta: { requiresAuth: true }
              },
              {
                path: "fields/:customer_field_id/edit",
                name: "Edit Customer Field",
                component: CustomerFieldEdit,
                meta: { requiresAuth: true }
              }
            ]
          }
        ]
      }
    ];

    this.public_routes = [];
  }

  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}
